import styled from '@emotion/styled';
import { Button, PresetThemes } from '@travelnest/merlin.button';

import * as React from 'react';
import { IProperty } from '../../../../data/entities/property';
import { IChannel } from '../../../../entities/contracts/types';
import { FormInput, FormLabel, FormLabelHelp, FormRow } from '../../../components/form';

const Wrapper = styled.div`

	.action-row {
		width: 582px;
		display: grid;
		grid-template-columns: 70% 30%;
		grid-gap: 0px;
		align-items: center;

		Label {
			justify-self: center;
		}

		Button {
			margin-left: 0px;
			width: 140px;
			height: 46px;
		}
	}

`;

const sortDirectListings = (properties: IProperty[], channels: IChannel[]) => {

	const propertyListings = [];
	const directChannel = channels.find((channel) => channel.id === 'direct');
	if (directChannel?.active) {
		for (const propId in properties) {
			if (properties[propId].is_active && properties[propId].published_at !== null) {
				propertyListings.push({
					propertyId: propId,
					hasActiveURL: true
				});
			} else {
				propertyListings.push({
					propertyId: propId,
					hasActiveURL: false
				});
			}
		}
	}

	return propertyListings;
};

interface IDirectListingLinksProps {
	properties: IProperty[];
	channels: IChannel[];
}

export const DirectListingLinks: React.FC<IDirectListingLinksProps> = (props) => {

	const { properties, channels } = props;

	const propertyListings = sortDirectListings(properties, channels);
	const sortedListings = propertyListings.sort((a, b) => Number(b.hasActiveURL) - Number(a.hasActiveURL));
	const linkElements = [
		...sortedListings.map((p) => {
			if (p.hasActiveURL === true) {
				const url = `https://direct.travelnest.com/properties/${p.propertyId}`;

				return [
					<FormRow>
						<Wrapper>
							<FormLabel htmlFor="rule-selector">{properties[p.propertyId].name}</FormLabel>
							<div className="action-row">
								<FormInput value={url} readOnly={true} />
								<Button
									buttonType={PresetThemes.Primary}
									onClick={() => { navigator.clipboard.writeText(url); }}
									disabled={false}>
									<img src={'/92b3b47/assets/icons/copy.svg'}></img> Copy Link
								</Button>
							</div>
						</Wrapper>
					</FormRow>
				];
			} else {
				return [
					<FormRow>
						<Wrapper>
							<FormLabel htmlFor="rule-selector">{properties[p.propertyId].name}</FormLabel>
							<div className="action-row">
								<FormLabelHelp>This could be due to not being published yet</FormLabelHelp>
								<Button
									bgColor={'#E2E5E9'}
									color={'#0A182B'}>
									Not available
								</Button>
							</div>
						</Wrapper>
					</FormRow>
				];
			}
		})
	];
	return (
		<>
			{linkElements}
		</>
	);
};
